(function (window, document, undefined) {

    //Domain for pixel
    var pixelURL = '//c1.ox-bio.com/t0?';

    //grab this script
    var thisScript = document.getElementsByTagName('script')[document.getElementsByTagName('script').length - 1];

    /**
     * Creates and appends a img DOM element in the current document with the provided URL
     * @function createElement
     * @param {String} src - The URL source for the element
     */
    var createElement = function createElement(src) {
        var element = document.createElement('script');
        element.src = src;
        element.async = true;
        document.body.appendChild(element);
    };

    /**
     * Return an object filled with the query string key value pairs
     * @function getParametersFromUrl
     * @param {String} url - The URL with the query string
     * @returns {Object}
     */
    var getParametersFromUrl = function getParametersFromUrl(url) {
        var queryString = url.split('?')[1];
        var pairs = queryString.split('&');
        var params = {};
        pairs.forEach(function (pair) {
            pair = pair.split('=');
            params[pair[0]] = decodeURIComponent(pair[1].replace(/\+/g, '%20') || '');
        });
        return JSON.parse(JSON.stringify(params));
    };

    /**
     * Take all the key value pairs from the provided object and combine those that do not start with
     * np. to create a string that will be used as the query string for the pixel
     * @function serializeURL
     * @param {Object} obj - the parameter object
     * @returns {String} the query string for the pixel url
     */
    var serializeURL = function serializeURL(obj) {
        var str = [];
        for (var p in obj) {
            if (obj.hasOwnProperty(p) && p.substr(0, 3) !== 'np.') {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        }
        return str.join("&");
    };

    //fill params with query string parameters that this script was called with
    var params = getParametersFromUrl(thisScript.src);

    //If creative has the correct size, fire pixel
    //    if ((params['np.size'] === '970x250') || (params['np.size'] === '300x600') || (params['np.size'] === '300x250')) {
    if (params['np.size'] === '300x600') {
        var uri = pixelURL + serializeURL(params);
        createElement(uri);
    }
})(window, document);